import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateJobPostRequest } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { jobPostSchema } from './schemas';
import { jobPostQueryOptions } from './useJobPost';

export const useCreateJobPost = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: CreateJobPostRequest) => {
      const { data: jobPost } = await fetchJson('/job-posts', {
        method: 'POST',
        schema: apiResourceSchema(jobPostSchema),
        body,
      });

      return jobPost;
    },
    onSuccess: (jobPost) => {
      queryClient.setQueryData(jobPostQueryOptions(jobPost.id).queryKey, jobPost);
      queryClient.invalidateQueries({ queryKey: QueryKeys.jobPosts.index.root });
    },
  });
};
